export default __webpack_public_path__ + "static/media/cards-icon.3f9f92d1.svg";